exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.actividadDespacho .estilo-grilla,\n.actividadDespacho #gridComponent {\n  height: auto !important;\n  margin-bottom: 50px;\n}\n", ""]);

// exports
